import { useState, useEffect,useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { CustomButton } from "../CustomButton";
import { classNames } from "primereact/utils";
import "./formStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../reducers/customerSlice";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form"
import { isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css';
import Loader from "../Loader";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
// 4.  POST https://api.skalebot.com/api/v1/user
// {   "userName": "deskala",
//     "password": "Skalebot@123",
//     "companyId": 8,
//     "phone": 919085595690   }
    
function Users({onHide}) {
    const toast = useRef();
    const [showPassword, setShowPassword] = useState(false);
    const [showPassForm, setPassForm] = useState(true);
   
    const {selectedcustomers,mode}=useSelector((state) => state.customer)
  
        const defaultValues = {
            companyId: selectedcustomers.companyId,
            userName: "",
            password: "",
            confirmPassword: "",
            phone:'',
        };
        
        const dispatch = useDispatch();
        
        const {
            control,
            formState: { errors },
            handleSubmit,
        } = useForm({ defaultValues });
        
        //function form get error message
        const getFormErrorMessage = (name) => {
            return (
            errors[name] && <small className="p-error">{errors[name].message}</small>
            );
        };
        const {loading} = useSelector((state) => state.customer);
        const onSubmit=(data)=>{
           if(!showPassForm){
            toast.current.show({ severity: 'error', detail: "Update Not Enabled" });
          }else{
            dispatch(addUser({ data}))
            .unwrap()
            .then(res => {
              toast.current.show({ severity: 'success', detail: "Company Added Succesfully" });
              onHide();  
            })
            .catch(err => {
              toast.current.show({ severity: 'error', detail: err.message });
            })}
        }
        const modalLoad = () => {
            return <Loader visible={loading} />;
          };
          const userSelector=()=>{
            return(
            <div className="field">
            <label htmlFor="User">User *</label>
            <Controller
                name="User"
                control={control}
                rules={{ required: "User is required." }}
                render={({ field, fieldState }) => (
                    <Dropdown
                    id={field.name}
                    optionLabel={`name`}
                    optionValue={`id`}
                    options={[]}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    placeholder="Select a User"
                    {...field}
                  />
                )}
            />
            {getFormErrorMessage("User")}
            </div>)
          }
          const switcher=()=>{
            return (<div className="flex flex-row w-12">
                <div className={`flex align-items-center justify-content-center cursor-pointer w-6 pb-2 mb-2 ${showPassForm?"sl-underline":""}`} onClick={()=>{setPassForm(true)}}>Add User</div>
                <div className={`flex align-items-center justify-content-center cursor-pointer w-6 pb-2 mb-2 ${showPassForm?"":"sl-underline"}`} onClick={()=>{setPassForm(false)}}>Manage Users</div>
                </div>)
          }
     if(showPassForm){
            return (
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            {modalLoad()}
            {switcher()}
            <Toast ref={toast}/>
            <div className="field ">
            <label htmlFor="companyId">Company  Id</label>
            <Controller
                name="companyId"
                control={control}
                rules={{ required: "companyID is required." }}
                render={({ field, fieldState }) => (
                <InputText
                    id={field.name}
                    maxLength={24}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    placeholder="Enter companyID here"
                    value={field.value}
                    {...field}
                    disabled
                />  
                )}
            />
            {getFormErrorMessage("companyId")}
            </div>
            <div className="field">
            <label htmlFor="userName">Username *</label>
            <Controller
                name="userName"
                control={control}
                rules={{ required: "Customer name is required." }}
                render={({ field, fieldState }) => (
                <InputText
                    id={field.name}
                    maxLength={24}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    placeholder="Enter customer user name here"
                    {...field}
                />
                )}
            />
            {getFormErrorMessage("userName")}
            </div>
            <div className="field">
            <label htmlFor="phone">Phone *</label>
            <Controller
                name="phone"
                control={control}
                rules={{ required: "phone number is required.",
                // validate:value=> value.toString().length == 10 || "Please enter a valid phone number. " 
                validate:value => isValidPhoneNumber(value.toString()) || "Please enter a valid phone number. " 
            }}
                render={({ field, fieldState }) => (
                <PhoneInputWithCountry
                    name="phone"
                    control={control}
                    defaultCountry="IN"
                    id={field.name}
                    placeholder="Enter phone number"
                    value={field.value}
                    onChange={(e)=>field.onChange(e.value)}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    {...field}
                />
                )}
            />
            {getFormErrorMessage("phone")}
            </div>
            <div className="field">
            <label htmlFor="email">Email</label>
            <Controller
                name="email"
                control={control}
                rules={{
                required: false,
                pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Enter a valid e-mail address",
                },
                }}
                render={({ field, fieldState }) => (
                <InputText
                    id={field.name}
                    value={field.value}
                    onChange={(e) => field.onChange(e.value)}
                    placeholder="Enter your email here"
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    {...field}
                />
                )}
            />
            {getFormErrorMessage("email")}
            </div>
            <div className="field">
                <label htmlFor="password">Password</label>
                <Controller
                    name="password"
                    control={control}
                    rules={{ required: true && "Please enter password." }}
                    render={({ field, fieldState }) => (
                    <span className="p-input-icon-right">
                        <i
                        className={`pi ${
                            showPassword ? "pi-eye" : "pi-eye-slash"
                        }`}
                        onClick={() => setShowPassword((prev) => !prev)}
                        />
                        <InputText
                        type={`${showPassword ? "text" : "password"}`}
                        id={field.name}
                        placeholder="Enter password"
                        {...field}
                        className={classNames({
                            "p-invalid": fieldState.invalid,
                        })}
                        />
                    </span>
                    )}
                />
                {getFormErrorMessage("password")}
            </div>
            <div>
            <CustomButton
                varient="filled"
                type="submit"
                label={"Continue"}
            />
            </div>
        
        </form>);
        
        }
    else
    return (  
    <>
    {switcher()}

    <form className="p-fluid">
    {userSelector()}
    </form>
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
    {modalLoad()}

    <Toast ref={toast}/>
    <div className="field">
            <label htmlFor="companyId">Company  Id</label>
            <Controller
                name="companyId"
                control={control}
                rules={{ required: "companyID is required." }}
                render={({ field, fieldState }) => (
                <InputText
                    id={field.name}
                    maxLength={24}
                    className={classNames({ "p-invalid": fieldState.invalid })}
                    placeholder="Enter companyID here"
                    value={field.value}
                    {...field}
                    disabled
                />
                )}
            />
            {getFormErrorMessage("companyId")}
            </div>
    <div className="field">
    <label htmlFor="userName">Username *</label>
    <Controller
        name="userName"
        control={control}
        rules={{ required: "Customer name is required." }}
        render={({ field, fieldState }) => (
        <InputText
            id={field.name}
            maxLength={24}
            className={classNames({ "p-invalid": fieldState.invalid })}
            placeholder="Enter customer user name here"
            {...field}
        />
        )}
    />
    {getFormErrorMessage("userName")}
    </div>
    <div className="field">
    <label htmlFor="phone">Phone *</label>
    <Controller
        name="phone"
        control={control}
        rules={{ required: "phone number is required.",
        // validate:value=> value.toString().length == 10 || "Please enter a valid phone number. " 
        validate:value => isValidPhoneNumber(value.toString()) || "Please enter a valid phone number. " 
    }}
        render={({ field, fieldState }) => (
        <PhoneInputWithCountry
            name="phone"
            control={control}
            defaultCountry="IN"
            id={field.name}
            placeholder="Enter phone number"
            value={field.value}
            onChange={(e)=>field.onChange(e.value)}
            className={classNames({ "p-invalid": fieldState.invalid })}
            {...field}
        />
        )}
    />
    {getFormErrorMessage("phone")}
    </div>
    <div className="field">
    <label htmlFor="email">Email</label>
    <Controller
        name="email"
        control={control}
        rules={{
        required: false,
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Enter a valid e-mail address",
        },
        }}
        render={({ field, fieldState }) => (
        <InputText
            id={field.name}
            value={field.value}
            onChange={(e) => field.onChange(e.value)}
            placeholder="Enter your email here"
            className={classNames({ "p-invalid": fieldState.invalid })}
            {...field}
        />
        )}
    />
    {getFormErrorMessage("email")}
    </div>
    <div className="field">
        <label htmlFor="password">Password</label>
        <Controller
            name="password"
            control={control}
            rules={{ required: true && "Please enter password." }}
            render={({ field, fieldState }) => (
            <span className="p-input-icon-right">
                <i
                className={`pi ${
                    showPassword ? "pi-eye" : "pi-eye-slash"
                }`}
                onClick={() => setShowPassword((prev) => !prev)}
                />
                <InputText
                type={`${showPassword ? "text" : "password"}`}
                id={field.name}
                placeholder="Enter password"
                {...field}
                className={classNames({
                    "p-invalid": fieldState.invalid,
                })}
                />
            </span>
            )}
        />
        {getFormErrorMessage("password")}
    </div>
   
    <div>
      <CustomButton
        varient="filled"
        type="submit"
        label={"Continue"}
    />
        </div>
    </form> </>
     );
}

export default Users;